import { useRef, useCallback, useMemo } from 'react';
import ddt from '@wix/da-ddt';
const logger = ddt.createLogger('customevent');
// this is like an extremely simplified and stripped down mini event emitter
// allows to create simple event subscription-like service for child components
export function useCustomEvent(name) {
    const callbacks = useRef([]);
    const emit = useCallback(()=>{
        callbacks.current.forEach(({ callback })=>callback());
        callbacks.current = callbacks.current.filter(({ once })=>!once);
        logger.log(`${name} - emitting`);
    }, [
        name
    ]);
    const subscription = useMemo(()=>({
            addListener: (callback, once = false)=>{
                callbacks.current = [
                    ...callbacks.current,
                    {
                        callback,
                        once
                    }
                ];
                logger.log(`${name} - adding listener`);
            },
            removeListener: (callback)=>{
                callbacks.current = callbacks.current.filter(({ callback: c })=>c !== callback);
                logger.log(`${name} - removing listener`);
            }
        }), [
        name
    ]);
    return {
        subscription,
        emit
    };
}

//# sourceMappingURL=useCustomEvent.js.map